<template>
  <div v-if="hasPermission('manage_shifts')" class="shift-table-controls" data-testid="shifts-actions-controls">
    <holiday-pay-code
      :initial-values="initialValues"
      :visible.sync="visibleHolidayModal"
      data-testid="shifts-holiday-pay-modal"
      @add="$emit('edit')"
    />
    <shift-pay-code
      :initial-values="initialValues"
      :visible.sync="visiblePayCodeModal"
      data-testid="shifts-pay-code-create-modal"
      @add="$emit('edit')"
    />
    <add-multiple-shifts
      :visible="visibleAddMultipleShiftsModal"
      :initial-values="initialValues"
      data-testid="shifts-add-multiple-modal"
      @close="closeMultipleShiftsModal"
    />
    <shift-edit
      :visible.sync="visibleAddShiftModal"
      :initial-values="initialValues"
      data-testid="shifts-add-shift-modal"
      @edit="$emit('edit')"
    />
    <shift-move
      :initial-values="initialValues"
      :visible.sync="visibleMoveShiftsModal"
      data-testid="shifts-move-shifts-modal"
      @move="$emit('edit')"
    />

    <import-clipboard :visible.sync="visibleImportShiftsModal" data-testid="shifts-import-invoice-modal" />

    <button-more :menu-items="addShiftMenuItems" menu-test-id="shifts-add-shift-menu">
      <template #trigger="{}">
        <a-button
          type="primary"
          @click.stop="() => {}"
          class="flex align-items-center justify-content-center gap-2"
          title="Add Shift"
          data-testid="shifts-add-shift-button"
        >
          <a-icon width="20" height="20" icon="fluent:add-20-regular" />
          Add Shift
        </a-button>
      </template></button-more
    >
    <button-more :menu-items="addPayCodeMenuItems" menu-test-id="shifts-add-pay-code-menu">
      <template #trigger="{}">
        <a-button
          type="primary"
          @click.stop="() => {}"
          class="flex align-items-center justify-content-center gap-2"
          title="Add Shift"
          data-testid="shifts-add-pay-code-button"
        >
          <a-icon width="20" height="20" icon="fluent:add-20-regular" />
          Add Pay Code
        </a-button>
      </template></button-more
    >
    <button-more :menu-items="menuMoreItems" menu-test-id="shifts-more-menu">
      <template #trigger="{}">
        <a-button
          @click.stop="() => {}"
          class="flex align-items-center justify-content-center gap-2"
          data-testid="shifts-more-button"
          title="More"
        >
          <a-icon width="20" height="20" icon="material-symbols:menu" />
          More
          </a-button>
        </template>
      </button-more>
  </div>
</template>

<script>
import ShiftMultiplyModal from '../modal/shift-multiply-modal.vue'
import ShiftForm from '../form/shift-form.vue'
import { Button } from 'ant-design-vue'
import ShiftMoveModal from '../modal/shift-move-modal.vue'
import featureMixin from '@/mixins/featureMixin'
import HolidayPay from '../pay-code/holiday-pay.vue'
import ShiftImportClipboard from './shift-import-clipboard.vue'
import permissionMixin from '@/mixins/permissionMixin'
import ShiftPayCodeCreateModal from '../pay-code/shift-pay-code-create-modal.vue'

export default {
  components: {
    'a-button': Button,
    'shift-pay-code': ShiftPayCodeCreateModal,
    'holiday-pay-code': HolidayPay,
    'add-multiple-shifts': ShiftMultiplyModal,
    'shift-edit': ShiftForm,
    'shift-move': ShiftMoveModal,
    'import-clipboard': ShiftImportClipboard
  },
  props: {
    initialValues: {
      type: Object,
      default: () => {
        return {
          associate_id: undefined,
          associateNumber: undefined,
          start: null,
          end: null
        }
      }
    }
  },
  data() {
    return {
      visibleMoveShiftsModal: false,
      visibleHolidayModal: false,
      visibleAddMultipleShiftsModal: false,
      visibleAddShiftModal: false,
      visibleImportShiftsModal: false,
      visiblePayCodeModal: false
    }
  },
  mixins: [featureMixin, permissionMixin],
  computed: {
    addShiftMenuItems() {
      return [
        {
          key: 'add-shift',
          icon: 'fluent:add-20-regular',
          label: 'Add Shift',
          testId: 'shifts-actions-add-shift-menu-item',
          visible: true,
          handler: () => {
            this.openAddShiftModal()
          }
        },
        {
          key: 'add-several-shift',
          icon: 'fluent:people-add-20-regular',
          label: 'Add Several Shifts',
          testId: 'shifts-actions-add-several-shifts-menu-item',
          visible: true,
          handler: () => {
            this.openMultipleShiftsModal()
          }
        }
      ]
    },
    addPayCodeMenuItems() {
      return [
        {
          key: 'add-pay-code',
          icon: 'fluent:add-20-regular',
          label: 'Add One / Several',
          testId: 'shifts-actions-add-pay-code-menu-item',
          visible: true,
          handler: () => {
            this.openPayCodeModal()
          }
        },
        {
          key: 'apply-holiday-pay-code',
          icon: 'fluent:calendar-star-20-regular',
          label: ' Apply Holiday',
          testId: 'shifts-actions-apply-holiday-pay-code-menu-item',
          visible: true,
          handler: () => {
            this.openHolidayModal()
          }
        }
      ]
    },
    menuMoreItems() {
      return [
        {
          key: 'move-shifts',
          icon: 'fluent:arrow-move-20-regular',
          label: 'Move Shifts',
          testId: 'shifts-actions-move-shifts-menu-item',
          visible: true,
          handler: () => {
            this.openMoveShiftsModal()
          }
        },
        {
          key: 'import-invoice',
          icon: 'fluent:clipboard-paste-20-regular',
          label: 'Import Invoice',
          testId: 'shifts-actions-import-invoice-menu-item',
          visible: true,
          handler: () => {
            this.openImportShiftsModal()
          }
        }
      ]
    }
  },
  methods: {
    openMoveShiftsModal() {
      this.visibleMoveShiftsModal = true
    },
    openPayCodeModal() {
      this.visiblePayCodeModal = true
    },
    openMultipleShiftsModal() {
      this.visibleAddMultipleShiftsModal = true
    },
    openAddShiftModal() {
      this.visibleAddShiftModal = true
    },
    openHolidayModal() {
      this.visibleHolidayModal = true
    },
    openImportShiftsModal() {
      this.visibleImportShiftsModal = true
    },
    closeMultipleShiftsModal(duplicatedShifts) {
      this.visibleAddMultipleShiftsModal = false

      if (duplicatedShifts) {
        this.$emit('edit')
      }
    }
  }
}
</script>

<style scoped>
.shift-table-controls {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
</style>
